/**
 * StrayPaw — kullanıcının ülkesi.
 *
 * Backend, fotoğrafı hangi ülkenin R2 bucket'ına yazacağını `X-Country`
 * başlığından öğreniyor (veri ikametgahı). Bu dosya o kodu belirler.
 *
 * Sıra:
 *   1. Kullanıcının uygulama içinden yaptığı seçim (localStorage)
 *   2. Cihaz dilinin bölge kodu (tr-TR → tr, pt-BR → br, es-ES → es)
 *   3. Yalnızca dil bilgisi varsa dilden çıkarım (hi → in, ar → eg, pl → pl)
 *   4. Derleme zamanı varsayılanı (REACT_APP_DEFAULT_COUNTRY)
 */

export const SUPPORTED_COUNTRIES = ["in", "br", "eg", "pl", "es", "id"];

const STORAGE_KEY = "straypaw_country";

// Dil kodundan makul bir ülke tahmini. Yalnızca desteklediğimiz 5 pazar için.
const LANG_TO_COUNTRY = {
  hi: "in", // Hintçe → Hindistan
  pt: "br", // Portekizce (uygulamada pt-BR) → Brezilya
  ar: "eg", // Arapça → Mısır
  pl: "pl", // Lehçe → Polonya
  es: "es", // İspanyolca → İspanya
  id: "id", // Endonezce → Endonezya
};

function normalize(code) {
  if (!code || typeof code !== "string") return null;
  const c = code.trim().toLowerCase().slice(0, 2);
  return SUPPORTED_COUNTRIES.includes(c) ? c : null;
}

/** Cihazın diline göre ülke tahmini: "pt-BR" → "br", "hi" → "in". */
function fromDeviceLocale() {
  const locales = [];
  if (typeof navigator !== "undefined") {
    if (navigator.languages) locales.push(...navigator.languages);
    if (navigator.language) locales.push(navigator.language);
  }

  for (const loc of locales) {
    const parts = String(loc).split(/[-_]/);
    // Önce bölge kodu (pt-BR → BR); tanıdığımız bir pazarsa onu kullan.
    if (parts[1]) {
      const region = normalize(parts[1]);
      if (region) return region;
    }
  }
  // Bölge yoksa ya da tanımadıysak dilden çıkarım yap (hi → in).
  for (const loc of locales) {
    const lang = String(loc).split(/[-_]/)[0].toLowerCase();
    const guess = LANG_TO_COUNTRY[lang];
    if (guess) return guess;
  }
  return null;
}

/** Etkin ülke kodu. Her zaman desteklenen 5 ülkeden biri döner. */
export function getCountry() {
  let stored = null;
  try {
    stored = localStorage.getItem(STORAGE_KEY);
  } catch (e) {
    // Gizli sekme / depolama kapalı — sorun değil, tahmine düşeriz.
  }
  return (
    normalize(stored) ||
    fromDeviceLocale() ||
    normalize(process.env.REACT_APP_DEFAULT_COUNTRY) ||
    "in"
  );
}

/** Kullanıcı ülkesini elle seçtiğinde çağrılır. */
export function setCountry(code) {
  const c = normalize(code);
  if (!c) return false;
  try {
    localStorage.setItem(STORAGE_KEY, c);
  } catch (e) {
    return false;
  }
  return true;
}
